import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import CCrud from "components/Molecules/Crud";
import { initialValues, structure, validationSchema } from "./structure";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, Stack } from "@mui/material";
import Breadcrumb from "components/Atoms/SharedComponents/Breadcrumbs/Breadcrumb";
import AddIcon from "@mui/icons-material/Add";
import { images } from "assets/AssetHelper";
import { detailsData } from "./details";

const ThemesTemplate = ({
  handlePageChange,
  data,
  details,
  count,
  handelSubmit,
  deleteFun,
  filterList,
  actionsList,
  breadcrumbs,
  setFilterObj,
  rowData,
  paginationPage,
  headerChildren,
  modalComponents,
  openDeleteModal,
  setOpenDeleteModal,
  handleDeleteRequest,
  can_create,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  let [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  const [supportedLang] = useState("en");
  return (
    <>
      <Box>
        <Stack
          direction="row"
          alignSelf="start"
          justifyContent="start"
          gap={2}
          width="100%"
          // mb={1}
        >
          <Breadcrumb data={breadcrumbs} />
        </Stack>
        <CCrud
          detailsTemplateData={{
            pageTitle: t("lookups_themes.title"),
            data: {
              images: [{ id: 0, img: images.Logo }],
              list: detailsData({ data: details, t }),
            },
          }}
          table={{
            list: data, // data
            listTitle: t("lookups_themes.title"), //title
            createBtnTitle: can_create && t("lookups_themes.add"), // action
            CreateBtnIcon: AddIcon,
            createBtnFun: () => navigate("?type=form"),
            columns: [
              { accessor: "id", Header: "#" },
              {
                accessor: "image_url",
                Header: t("common.image"),
              },
              {
                accessor: "localized_data.en.name",
                Header: t("lookups_themes.name_en"),
                sort: true,
              },
              {
                accessor: "localized_data.ar.name",
                Header: t("lookups_themes.name_ar"),
                sort: true,
              },
              {
                accessor: "localized_data.en.description",
                Header: t("lookups_themes.description_en"),
                sort: true,
              },
              {
                accessor: "localized_data.ar.description",
                Header: t("lookups_themes.description_ar"),
                sort: true,
              },
              {
                accessor: "created_at",
                Header: t("details.created_at"),
                sort: true,
              },
              { accessor: "Actions", Header: t("cart_logs.actions") },
            ],
            isSearch: false,
            searchInputPlaceholder: t("lookups_themes.search_placeholder"),
            isChecked: false,
            total_count: count,
            setFilterObj,
            className:
              "organization-table system-configurations-table main-table",
            paginationPage: paginationPage,
            handlePageChange,
            rowData: rowData,
            filterList,
            actionsList, //if you want to add custom actions list ...
            headerChildren,
            details,
            openDeleteModal,
            setOpenDeleteModal,
            handleDeleteRequest,
          }}
          form={{
            initialValues: !id ? {} : initialValues(details, supportedLang),
            structure: () => structure(supportedLang, null, t),
            validationSchema: validationSchema,
            deleteFun: deleteFun,
            title: id ? t("lookups_themes.edit") : t("lookups_themes.add"),
            submitTitle: id
              ? t("admin_users.btn_update")
              : t("admin_users.btn_add"),
            onSubmit: handelSubmit,
            className: { form: "main-form", actionButton: "main-form-buttons" },
          }}
          modalComponents={modalComponents}
        />
      </Box>
    </>
  );
};

export default ThemesTemplate;
